import { lazy } from 'react';

const LazyXeroOAuthCallbackPage = lazy(() => import('./xero-oauth-callback-page'));
export default LazyXeroOAuthCallbackPage;
